import { useState } from "react";
import { formatToTwoDecimalPlaces } from "../utils";
import { message, notification } from "antd";
import { bank_reconciliation_manager } from "../../../services";

export const useReconciliationManagmentForTransactionsHook = (
	invoicesData = [], 
	bankAccountSelectedCurrency = "",
	isEditable = false,
) => {
	// Taking control of the correspondients conections:
	const [selectedTransaction, setSelectedTransaction] = useState({});
	const [invoicesToSend, setInvoicesToSend] = useState({});
	const [invoiceRegistersToDelete, setInvoiceRegistersToDelete] = useState([]);
	const [api, contextHolder] = notification.useNotification();
	
	const {
		id: idTransaction,
		amount,
		position,
		reconciliation: { invoices: originalInvoices = {} } = {},
	} = selectedTransaction;
	
	const openNotification = (failedTransactions) => {
		api.open({
			message: "Facturas no Reconciliadas",
			description: `${failedTransactions.map((register) => `○ ${register}\n`)}`,
			duration: 0,
		});
	};
	
	// For Add the Register Invoice to the Invoices To Send to the Transaction
	const processInvoiceToSend = ({ invoiceId, checked, inInvoicePaid = false, outInvoicePaid = false }) => {
		if(checked){
			if(position === "in" && inInvoicePaid && !originalInvoices[invoiceId]){
				message.error("La transacción en su VENTA, ya ha sido cubierta por completo");
				return;
			}
	
			if(position === "out" && outInvoicePaid && !originalInvoices[invoiceId]){
				message.error("La transacción en su COMPRA, ya ha sido cubierta por completo");
				return;
			}
			
			const {
				position: positionFromInvoice = "",
				date = "",
				reconciliation: { 
					in: transactionsCoveringIn = {},
					out: transactionsCoveringOut = {},
				} = {},
				currency = "",
				total,
				reference,
				percentage = 0.00,
			} = invoicesData.find((inv) => inv.id === invoiceId);

			const amount = 0.00;

			if(positionFromInvoice !== position){
				message.error("La posición de la transacción no coincide con la posición de la factura");
				return;
			}
			
			if(currency !== bankAccountSelectedCurrency){
				message.error("La moneda de la transacción no coincide con la moneda de la factura");
				return;
			}

			const selectedTransactionsCovering = position === "in" ? transactionsCoveringIn : transactionsCoveringOut;
			const totalCoveredSelectedConvering = Object.values(selectedTransactionsCovering).reduce(
				(accumulator, item) => accumulator += item.amount
				, 0);
			
			const pendientValue = formatToTwoDecimalPlaces(total - totalCoveredSelectedConvering - amount);
				
			// ? ==> Set escential data for the invoice to send
			setInvoicesToSend({
				...invoicesToSend,
				[invoiceId]: {
					id: invoiceId,
					amount,
					reference,
					total,
					date,
					initial_pendient: pendientValue,
					pendient: pendientValue,
					total_payed: formatToTwoDecimalPlaces(percentage),
				},
			});
		} else {
			const invoicesToSendCopy = {...invoicesToSend};
			delete invoicesToSendCopy[invoiceId];
			setInvoicesToSend(invoicesToSendCopy);
		}
	};

	const updateInvoiceAmount = ({ value, invoiceId }) => {
		const invoice = invoicesData.find((inv) => inv.id === invoiceId);

		const {			
			reconciliation: { 
				in: transactionsCoveringIn = {},
				out: transactionsCoveringOut = {},
			} = {} 
		} = invoice ?? {};

		const amount = formatToTwoDecimalPlaces(value);
		const selectedTransactionsCovering = position === "in" ? transactionsCoveringIn : transactionsCoveringOut;
		const updatedSelectedTransactionsCovering = { ...selectedTransactionsCovering, [idTransaction]: { amount }};
		const totalCoveredSelectedConvering = Object.values(updatedSelectedTransactionsCovering).reduce(
			(accumulator, item) => accumulator += item.amount
			, 0);

		const invoiceToSend = invoicesToSend[invoiceId];
		const total = formatToTwoDecimalPlaces(invoiceToSend.total);				
		const pendient = total - formatToTwoDecimalPlaces(totalCoveredSelectedConvering);

		setInvoicesToSend({
			...invoicesToSend,
			[invoiceId]: {
				...invoiceToSend,
				amount,
				pendient,
				total_payed: (formatToTwoDecimalPlaces(totalCoveredSelectedConvering) / formatToTwoDecimalPlaces(invoiceToSend.total)) * 100,
			},
		});
	};

	const changeSelectedTransaction = (data, invoicesBackupData = [], onFilterInvoicesByProperty = () => {}) => {
		const { 
			reconciliation: { 
				invoices: invoicesFromTemporalTransactionReconciliation = {}, transaction_consumed = false 
			} = {},
			position: positionFromTemporalTransaction = "",
		} = data;

		if(transaction_consumed && !isEditable){
			message.warning("No vas a poder cambiar la reconciliación, ya que esta transacción ya se consumio por completo");
		}
		
		setInvoicesToSend({});
		setInvoiceRegistersToDelete([]);
		setSelectedTransaction(data);		
		onFilterInvoicesByProperty("position", data.position ?? "");

		const invoicesKeys = Object.keys(invoicesFromTemporalTransactionReconciliation);
		
		const updatedInvoicesToSend = invoicesKeys.reduce((accumulator, invoiceId) => {
			const invoiceFounded = invoicesFromTemporalTransactionReconciliation[invoiceId];
			const { amount, reference, total = 0.00, date = "N/A" } = invoiceFounded;

			const invoice = invoicesBackupData.find((inv) => inv.id === invoiceId);
			const { 			
				reconciliation: { in: transactionsCoveringIn = {}, out: transactionsCoveringOut = {} } = {},
				percentage = 0.00,
			} = invoice ?? {};
			
			const selectedTransactionsCovering = positionFromTemporalTransaction === "in" ? transactionsCoveringIn : transactionsCoveringOut;
			const totalCoveredSelectedConvering = Object.values(selectedTransactionsCovering).reduce(
				(accumulator, item) => accumulator += item.amount
				, 0);
			
			const pendientAmount = formatToTwoDecimalPlaces(total) - formatToTwoDecimalPlaces(totalCoveredSelectedConvering);
				
			return {
				...accumulator,
				[invoiceId]: {												
					amount,
					reference,
					id: invoiceId,
					total,
					date,
					pendient: pendientAmount,
					initial_pendient: pendientAmount,
					total_payed: formatToTwoDecimalPlaces(percentage),
					notAtInvoices: !invoice,
				},
			};
		}, {});
		
		setInvoicesToSend(updatedInvoicesToSend);
	};
	
	const fetchSendReconciliation = async ({
		token, 
		companySelectedId,
		onLoading = () => {},
		onUpdateReconciliationTransactionInFetch = () => {},
		onUpdateReconciliationInvoicesInFetch = () => {},
	}) => {
		if(Object.values(originalInvoices).length === 0 && Object.values(invoicesToSend).length === 0){
			message.error("No se ha agregado ninguna factura para realizar la reconciliación bancaria");
			return;
		}
		
		const refactorizedInvoicesToSend = Object.fromEntries(
			Object.entries(invoicesToSend).map(([id, { amount, reference, total, date }]) => [id, { amount, reference, total, date }])
		);
				
		if(JSON.stringify(originalInvoices) === JSON.stringify(refactorizedInvoicesToSend)){
			message.error("No se ha realizado un solo cambio para modificar la reconciliación bancaria");
			return;
		}
		
		const invoicesWithoutAmount = Object.values(invoicesToSend).filter(
			(invoice) => invoice.amount === 0.00
		);
	
		if (invoicesWithoutAmount.length > 0) {
			message.error("Por favor, ingrese el monto a conciliar de las facturas que no tienen un amount ingresado.");
			return;
		}

		const invoicesToSet = Object.fromEntries(
			Object.entries(invoicesToSend).filter(([id, { amount }]) => {
				return !originalInvoices[id] || originalInvoices[id].amount !== amount;
			}).map(([id, { amount }]) => [id, { amount }])
		);
			
		const data = {
			bank_transaction_id: idTransaction,
			company_id: companySelectedId,
			invoices_to_set: invoicesToSet,
			invoices_to_delete: invoiceRegistersToDelete,
		};
	
		try {
			onLoading(true);
			const res = await bank_reconciliation_manager(token, "edit", data);
	
			if (!res) {
				onLoading(false);
				return;
			}
	
			const { message: messageRes = "", invoices = [], failedRegisters: failedInvoicesRegisters = [] } = res;
	
			const invoicesRegistersToRemove = invoiceRegistersToDelete.filter(
				(idInvoice) => !failedInvoicesRegisters.includes(idInvoice)
			);

			// ? ============================================================================================
			// ? ==> Actualizar reconciliación en la transacción bancaria
			const updatedTransactionInvoices = { ...originalInvoices, ...refactorizedInvoicesToSend };
	
			invoicesRegistersToRemove.forEach((invoiceId) => {
				delete updatedTransactionInvoices[invoiceId];
			});

			const totalAmountInvoicesForReconciliation = Object.values(updatedTransactionInvoices).reduce(
				(accumulator, invoice) => accumulator += invoice.amount,
				0
			);

			const remainingAmount = formatToTwoDecimalPlaces(amount) - formatToTwoDecimalPlaces(totalAmountInvoicesForReconciliation);
			
			onUpdateReconciliationTransactionInFetch(updatedTransactionInvoices, remainingAmount);
			
			// ? ============================================================================================
			// ? ==> Actualizar reconciliación en las facturas
			const invoicesToUpdate = {};
			const isOutgoing = position === "out";
				
			Object.entries(invoicesToSet).forEach(([invoiceId, { amount }]) => {
				if (!failedInvoicesRegisters.includes(invoiceId)) {
					const invoiceData = invoicesData.find((inv) => inv.id === invoiceId);
					const reconciliationType = isOutgoing ? "out" : "in";
			
					// Obtener la reconciliación actual y agregar el nuevo monto
					const updatedReconciliation = {
						...invoiceData?.reconciliation?.[reconciliationType],
						[idTransaction]: { amount },
					};
			
					// Calcular el total conciliado sumando todos los montos
					const totalReconciled = Object.values(updatedReconciliation).reduce(
						(acc, { amount }) => acc + amount, 0
					);
			
					// Determinar si la factura ya está pagada
					const isInvoicePaid = totalReconciled >= invoiceData.total;
			
					// Actualizar la reconciliación con la bandera correspondiente
					invoicesToUpdate[invoiceId] = {
						reconciliation: {
							...invoiceData?.reconciliation,
							[reconciliationType]: updatedReconciliation,
							[isOutgoing ? "invoice_out_paid" : "invoice_in_paid"]: isInvoicePaid,
						},
						percentage: formatToTwoDecimalPlaces(((totalReconciled / invoiceData.total) * 100)),
					};
				}
			});
				
			invoicesRegistersToRemove.forEach((invoiceId) => {
				const invoice = invoicesData.find((inv) => inv.id === invoiceId);
				if (invoice) {
					const reconciliationCopy = { ...invoice.reconciliation };
					const reconciliationType = isOutgoing ? "out" : "in";
			
					if (reconciliationCopy[reconciliationType]) {
						delete reconciliationCopy[reconciliationType][idTransaction];
					}
			
					const updatedReconciliation = reconciliationCopy[reconciliationType] || {};
					const totalReconciled = Object.values(updatedReconciliation).reduce(
						(acc, { amount }) => acc + amount, 0
					);
			
					const isInvoicePaid = totalReconciled >= invoice.total;
			
					invoicesToUpdate[invoiceId] = {
						reconciliation: {
							...reconciliationCopy,
							[isOutgoing ? "invoice_out_paid" : "invoice_in_paid"]: isInvoicePaid,
						},
						percentage: formatToTwoDecimalPlaces(((totalReconciled / invoice.total) * 100)),
					};
				}
			});

			onUpdateReconciliationInvoicesInFetch(invoices, invoicesToUpdate, failedInvoicesRegisters);
			
			// ? ============================================================================================
			// ? ==> Actualizar los datos esperados con respecto a eliminar los registros con exito
			const invoicesRegistersPendient = invoiceRegistersToDelete.filter(
				(idInvoice) => failedInvoicesRegisters.includes(idInvoice)
			);
			setInvoiceRegistersToDelete(invoicesRegistersPendient);
			
			message.info(messageRes);

			// ? ============================================================================================
			// ? ==> Notificacion de algunas transacciones fallidas
			if(invoicesRegistersPendient.length > 0){
				const failedInvoicesByReference = invoicesRegistersPendient.map((registerId) => {
					const invoiceData = invoicesData.find((inv) => inv.id === registerId);
					return invoiceData.reference ?? "N/A";
				});
				openNotification(failedInvoicesByReference);
			}			
		} catch (err) {
			message.error(err.response.data);
		} finally {
			onLoading(false);
		}
	};

	return {
		selectedTransaction,
		invoicesToSend,
		invoiceRegistersToDelete,
		setSelectedTransaction,
		setInvoicesToSend,
		setInvoiceRegistersToDelete,
		processInvoiceToSend,
		updateInvoiceAmount,
		changeSelectedTransaction,
		fetchSendReconciliation,
		contextHolderFailedInvoices: contextHolder,
	};
};